<template>
  <div class="performance-list-page">
    <date-range-performance
      title="本周销售业绩"
      :timeString="week"
      :amount="thisWeek.salesAmount"
      :count="thisWeek.salesCount"
    />
    <date-range-performance
      title="本月销售业绩"
      :timeString="month"
      :amount="thisMonth.salesAmount"
      :count="thisMonth.salesCount"
    />
    <date-range-performance
      title="上月销售业绩"
      :timeString="lastMonthLabel"
      :amount="lastMonth.salesAmount"
      :count="lastMonth.salesCount"
    />
    <date-range-performance
      title="本年销售业绩"
      :timeString="year"
      :amount="thisYear.salesAmount"
      :count="thisYear.salesCount"
    />
    <CBottomPad is-tab-page />
  </div>
</template>
<script>
import { getCAPerformance } from "@/api";
import CBottomPad from "@/components/common/CBottomPad.vue";
import DateRangePerformance from "@/components/dashboard/DateRangePerformance.vue";
import normalPage from "@/mixins/normal-page";
import { mapGetters } from "vuex";
export default {
  mixins: [normalPage],
  components: {
    DateRangePerformance,
    CBottomPad,
  },
  data() {
    const today = this.$moment();
    return {
      week:
        this.$moment().startOf("week").format("YYYY-MM-DD") +
        "～" +
        this.$moment().endOf("week").format("YYYY-MM-DD"),
      month: today.format("YYYY-MM"),
      lastMonthLabel: this.$moment().subtract(1, "month").format("YYYY-MM"),
      year:
        this.$moment().startOf("year").format("YYYY-MM-DD") +
        "～" +
        today.format("YYYY-MM-DD"),

      thisWeek: {
        salesAmount: 0,
        salesCount: 0,
      },
      thisMonth: {
        salesAmount: 0,
        salesCount: 0,
      },
      lastMonth: {
        salesAmount: 0,
        salesCount: 0,
      },
      thisYear: {
        salesAmount: 0,
        salesCount: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["currentStore", "canSwitchRole"]),
  },
  async mounted() {
    try {
      this.$toast.loading({
        message: "加载中",
        forbidClick: true,
      });
      const params = {};
      if (this.canSwitchRole) {
        if (this.currentStore?.storeId) {
          params.storeId = this.currentStore.storeId;
        }
      }
      const res = await getCAPerformance(params);
      // console.log("res", res);
      Object.assign(this, res);
      this.$toast.clear();
    } catch (error) {
      if (error?.message) this.$toast(error.message);
      else this.$toast.clear();
    }
  },
};
</script>
<style lang="less" scoped>
.performance-list-page {
  padding-top: 10/40rem;
  background-color: #f2f2f2;
}
</style>
